import React, { useState } from "react";
import { toast } from "sonner";
import { BusinessHeader, BusinessFooter } from "./BusinessHome";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail } from "lucide-react";

export default function BusinessContact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  const submit = () => {
    if (!name || !email || !msg) {
      toast.error("Please fill all fields");
      return;
    }
    // Non-blocking: for MVP just show success (could route to demo bookings or a separate table)
    toast.success("Thanks! We'll reply within 24h.");
    setName("");
    setEmail("");
    setMsg("");
  };

  return (
    <div className="min-h-screen">
      <BusinessHeader />
      <div className="max-w-3xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-6">
        <div>
          <h1 className="font-heading text-3xl font-bold text-brand-dark">Talk to us.</h1>
          <p className="text-brand-dark/60 mt-2">Partnership, enterprise, feedback — all welcome.</p>
          <div className="mt-4 space-y-2 text-sm text-brand-dark/80">
            <div className="flex items-center gap-2"><Mail size={14} /> support.tabdine@gmail.com</div>
          </div>
        </div>
        <div className="bg-white rounded-2xl border border-brand-dark/5 p-5 space-y-3">
          <Input placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} data-testid="c-name" />
          <Input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="c-email" />
          <textarea placeholder="How can we help?" value={msg} onChange={(e) => setMsg(e.target.value)} className="w-full min-h-[110px] rounded border border-input p-2 text-sm" data-testid="c-msg" />
          <Button onClick={submit} className="w-full bg-brand-orange text-white" data-testid="c-submit">Send message</Button>
        </div>
      </div>
      <BusinessFooter />
    </div>
  );
}
